import { useRootService } from '@kaokei/use-vue-service';
import { UserService } from '@core/services/user.service';

export default (el: any, binding: any) => {
  const userService = useRootService(UserService);
  const permissionName = binding.value;
  const isDisabledModifier = binding?.modifiers?.disabled;
  const isGroupModifier = binding?.modifiers?.group;
  const isOnlyModifier = binding?.modifiers?.only;
  const hasPermission = isGroupModifier
    ? userService.hasGroupAuth(permissionName)
    : isOnlyModifier
      ? userService.hasAuthOnly(permissionName)
      : userService.hasAuth(permissionName);

  if (!permissionName) return;

  if (hasPermission) {
    el.style.removeProperty('display');
    if (isDisabledModifier) {
      el.disabled = false;
    }
  } else {
    if (isDisabledModifier) {
      el.disabled = true;
    } else {
      el.style.display = 'none';
    }
  }
};
